import TimelineRequestElevatedEmailPermissionsCard from '../events/TimelineRequestElevatedEmailPermissionsCard';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineRequestElevatedEmailPermissionsCardWrapperV2 = ({
  currentUserEmail,
  portalDomain,
  useSlimMessage
}) => {
  if (!currentUserEmail || !portalDomain) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      flush: true,
      compact: true,
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(TimelineRequestElevatedEmailPermissionsCard, {
        currentUserEmail: currentUserEmail,
        portalDomain: portalDomain,
        useSlimMessage: useSlimMessage
      })
    })
  });
};
export default TimelineRequestElevatedEmailPermissionsCardWrapperV2;